export const Colors = {
    blue: '#0b0547',
    orange: '#DD563B',
    gray: '#737373;',
    white: '#ffffff',
}

export default Colors;